/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-named-as-default
import Dashboard from "layouts/dashboard";
// import XrayPictures from "layouts/xray_pictures";
// import Users from "layouts/users";
// import Customers from "layouts/customers";
// import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
// import CustomerSupport from "examples/Icons/CustomerSupport";
// import CreditCard from "examples/Icons/CreditCard";
import Orders from "layouts/orders";
import Payments from "layouts/payments";
import Suppliers from "layouts/suppliers";
import Vendors from "layouts/vendors";
import Accounting from "layouts/accounting";
// import Drugs from "layouts/drugs";
import Transactions from "layouts/transactions";
import Backups from "layouts/backups";
import AuditLog from "layouts/audit_log";
// import Expenses from "layouts/expenses";
import TestUsers from "layouts/users/test";
import Totals from "layouts/totals/totals";
import Customers from "layouts/customers";
import Containers from "layouts/containers";
import Notifications from "layouts/notifications";
import ShippingMark from "layouts/shipping_mark";
import NotificationSettingsPage from "layouts/notification_settings";
import AllOrders from "layouts/all_orders";
import Posts from "layouts/posts";
import Messages from "layouts/messages";
import Status from "layouts/status";
import CustomerOrders from "layouts/customer_orders";

// import { useTranslation } from "react-i18next";

// eslint-disable-next-line no-unused-vars
// const { t } = useTranslation();
const AdminRoutes = [
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <Office size="12px" />,
    component: <TestUsers />,
    noCollapse: true,
  },
  {
    // Merged into the Users tab (filters on role_id); route kept alive.
    type: "hidden",
    name: "Customers",
    key: "customers",
    route: "/customers",
    icon: <Office size="12px" />,
    component: <Customers />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    route: "/notifications",
    icon: <Office size="12px" />,
    component: <Notifications />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Shipping Mark",
    key: "shipping_mark",
    route: "/shipping-mark",
    icon: <Office size="12px" />,
    component: <ShippingMark />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "notification_settings",
    route: "/settings",
    icon: <Office size="12px" />,
    component: <NotificationSettingsPage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Containers",
    key: "containers",
    route: "/containers",
    icon: <Office size="12px" />,
    component: <Containers />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    route: "/orders",
    icon: <Office size="12px" />,
    component: <Orders excludeStatus="LOADED" />,
    noCollapse: true,
  },
  {
    // the Orders screen pinned to LOADED: what is on a container and gone,
    // which is the question the office asks often enough to want a tab for
    type: "collapse",
    name: "Loaded Orders",
    key: "loaded_orders",
    route: "/loaded_orders",
    icon: <Office size="12px" />,
    component: <Orders lockedStatus="LOADED" title="Loaded Orders" />,
    noCollapse: true,
  },

  {
    // No longer needed as a tab. The route stays registered so any saved
    // link still resolves; only the navigation entry is gone.
    type: "hidden",
    name: "All Orders",
    key: "all_orders",
    route: "/all_orders",
    icon: <Office size="12px" />,
    component: <AllOrders />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Payments",
    key: "payments",
    route: "/payments",
    icon: <Office size="12px" />,
    component: <Payments />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Suppliers",
    key: "suppliers",
    route: "/suppliers",
    icon: <Office size="12px" />,
    component: <Suppliers />,
    noCollapse: true,
  },
  {
    // suppliers that are not the Chinese ones - a list of its own, admin only
    type: "collapse",
    name: "Other Suppliers",
    key: "vendors",
    route: "/vendors",
    icon: <Office size="12px" />,
    component: <Vendors />,
    noCollapse: true,
  },
  {
    // vouchers, invoices, cash boxes & banks, categories - admin only
    type: "collapse",
    name: "Accounting",
    key: "accounting",
    route: "/accounting",
    icon: <Document size="12px" />,
    component: <Accounting />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Posts",
    key: "posts",
    route: "/posts",
    icon: <Office size="12px" />,
    component: <Posts />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    route: "/messages",
    icon: <Office size="12px" />,
    component: <Messages />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Status",
    key: "status",
    route: "/status",
    icon: <Office size="12px" />,
    component: <Status />,
    noCollapse: true,
  },
  {
    // restore points: save a copy of all the data, put it back with one click
    type: "collapse",
    name: "Backups",
    key: "backups",
    route: "/backups",
    icon: <Document size="12px" />,
    component: <Backups />,
    noCollapse: true,
  },
  {
    // who added, edited or deleted what, anywhere in the system - admin only
    type: "collapse",
    name: "Audit Log",
    key: "audit-log",
    route: "/audit-log",
    icon: <Document size="12px" />,
    component: <AuditLog />,
    noCollapse: true,
  },
];

export default AdminRoutes;
